require([
  'app/modules/job_wizard',
  'app/modules/forms',
  'vendor/sortable.min.js',
  'app/modules/utilities'
], function(JobWizard, Forms, Sortable, Util){
  JobWizard.updateBoardCountry($(".job-advertising #board_country").val());
  $.each($('.job-promote-edit .row-checkbox input:checked'), function(i, el){
    $(this).parents('tr').addClass('selected');
  });
  var el = document.getElementById('customQuestionsList');
  if (el) {
    Sortable.create(el, {
      handle: '.sort-custom-question',
      animation: 150,
      onEnd: function (evt) {
        $('#customQuestionsList .custom_question').each(function(index) {
          $(this).find('.index').html(index + 1);
        });
      }
    });
  }
  var selectedParams = {
    disable_search_threshold: 10,
    width: "100%",
    allow_single_deselect: true
  };
  $('.filter-office,.filter-teams,.filter-jobs').chosen({disable_search_threshold: 10, allow_single_deselect: true});

  $('#job_activity_id,#job_office_id,#job_employment_type,#job_currency,#job_salary,#job_experiences,#job_job_functions').chosen(selectedParams);

  $('#addCustomQuestion').on('click', function(e) {
      e.preventDefault();
      JobWizard.addCustomQuestion();
  });

  var $custom_questions = $('#custom_questions');

  $custom_questions.on('click', '.remove-custom-question', function(e) {
      e.preventDefault();
      JobWizard.removeCustomQuestion($(this));
  });

  $custom_questions.on('click', '.edit-custom-question', function(e) {
    e.preventDefault();
    var item = $(this).parents('.custom_question');
    var num = item.data("num");

    const $multiCheckbox = item.find('input.radio-icheck[value=multiple_choice]:checked');

    $custom_questions.find('.choice_options_wrapper').toggleClass('hidden', !$multiCheckbox.length);

    item.data("q-text", item.find("input[name='custom_questions["+num+"][text]']").val() );
    item.data("q-type", item.find("input[name='custom_questions["+num+"][type]']:checked").val() );
    item.data("q-required", item.find("input[name='custom_questions["+num+"][required]']:checked").val() || 0 );

    item.addClass('edit');
    JobWizard.checkListQuestion();
  });

  $custom_questions.on('click', '.btn-cancel', function(e) {
      e.preventDefault();
      var item = $(this).parents('.custom_question');

      if(item.data('isNew') && item.data('isNew') == 1) {
          item.remove();
      }
      else {
          var num = item.data("num");

          item.find("input[name='custom_questions["+num+"][text]']").val(item.data("q-text"));
          item.find("input[name='custom_questions["+num+"][type]']")
              .filter(function() {
                  return this.value == item.data("q-type")
              }).prop("checked", true);
          item.find("input[name='custom_questions["+num+"][required]']").prop("checked", item.data("q-required") ? true : false);
          item.removeClass('edit');
      }

      JobWizard.checkListQuestion();
  });

  $custom_questions.on('click', '.btn-add', function(e) {
      e.preventDefault();
      var item = $(this).parents('.custom_question')
          ,num = item.data("num")
          ,title = item.find('.view > .question-title');
      var value = item.find("input[name='custom_questions["+num+"][text]']").val();
      if(value){
        var multiple_choice = item.find('.type-block input.radio-icheck[value=multiple_choice]:checked').val();
        var multiple_choice_options = item.find('.choice_options .choice_option').not('.choice_options .choice_option.example');

        if((multiple_choice && multiple_choice_options.length > 0) || !multiple_choice){
          title.find('.index').html(num+1);
          title.find('.name').html(". " + value);
          item.data("isNew" , 0);
          item.removeClass('edit');

          JobWizard.checkListQuestion();
        }
      }
  });

  $custom_questions.find("input.radio-icheck").each(function() {
      var inpt_radio = $(this)
          ,max_words = $(inpt_radio.parents(".custom_question").find(".form-control__max-words")[0]);
      if(inpt_radio.prop("checked")) {
          max_words.prop('disabled', !!(inpt_radio.val() != "text"));
      }

      inpt_radio.on("ifChecked", JobWizard.onIfChecked);
  });

  $custom_questions.on('ifChecked', '.radio-icheck', function(){
    if($(this).val() == 'multiple_choice'){
      $custom_questions.find('.choice_options_wrapper').removeClass('hidden');
    } else {
      $custom_questions.find('.choice_options_wrapper').addClass('hidden');
    }
  });

  $custom_questions.on('click', '.new_choice_option .btn-add-choice-option', function(e){
    e.preventDefault();
    e.stopPropagation();

    var option = $(this).parents('.form-group').find('input#new_choice_options').val();
    JobWizard.addChoiceOption(option, $(this).parents('.choice_options_wrapper'));
  });

  $custom_questions.on('click', '.choice_option .remove-choice-option', function(e){
    e.preventDefault();
    e.stopPropagation();

    JobWizard.removeChoiceOption($(this));
  });

  $('.external-url__title').on('click', function(e) {
    e.preventDefault();
    JobWizard.showExternalUrl();
  });

  $('.save-job').on('click', function(e) {
    e.preventDefault();

    if(Forms.ignoreJobQuestionsDirtyInputs()) {
      JobWizard.saveJob($(this).parents('form'));
    }
  });

  $('.btn-next-step').on('click', function(e) {
    if(!Forms.ignoreJobQuestionsDirtyInputs()) {
      e.preventDefault();
    }
  });

  $(".switcher:not('.mandatory')").map(function() {
      var item = $(this);

      item.on("click", function() {
          var item = $(this);
          item.find(".switch-container").toggleClass("off");

          item.find("input[type=radio]").each(function() {
              var item = $(this);
              if(!item.prop("checked")) {
                  item.prop("checked", true);
                  return false;
              }
          });
      });
  });

  $('.modal-invite-member .invite-form').on('submit', function(e){
    e.preventDefault();
    Forms.submit($(this), 'invite_', function(){$('.modal-invite-member').modal('hide');document.location.reload();});
  });

  $(".job-advertising #board_country").chosen(selectedParams).on('change', function() {
    JobWizard.updateBoardCountry($(this).val());
  });

  $('.job-promote-edit .show-auth').on('click', function(e){
    e.preventDefault();
    $('tr.auth-params'+$(this).attr('href')).toggleClass('visible');
  });

  $('.job-promote-edit .row-checkbox input').on('ifChanged', function(){
    if($(this).is(':checked')){
      $(this).parents('tr').addClass('selected');
    } else {
      $(this).parents('tr').removeClass('selected');
    }
  });

  // Members section
  $(document).ready(function () {
    JobWizard.initMembersForm();
  });

  Util.applyClipboard('.copy-form-url', 'Use the URL to post it on regular websites and share in social media', true);
});
